import React from "react";
import { useTranslation } from "react-i18next";

const ProgressBarDownload = ({ progress }) => {
  const { t } = useTranslation();
  return (
    <div>
      {progress > 0 && (
        <div
          style={{
            width: "200px",
            height: "20px",
            backgroundColor: "lightgray",
          }}
        >
          <div
            style={{
              width: `${progress}%`,
              height: "100%",
              backgroundColor: "#6d5dfc",
            }}
          ></div>
          {progress === 100 ? (
            <span
              style={{
                fontWeight: 500,
              }}
            >
              {t("download.download_completed")}
            </span>
          ) : (
            <span
              style={{
                fontWeight: 500,
              }}
            >
              {t("download.download_in_progress", { progress })}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default ProgressBarDownload;
